module.exports = __webpack_public_path__ + "media/images/photo/Residential/slider1-e4cff38b1b24eebe5d479ddd7e834242.svg";